import { Box } from '@material-ui/core'
import React, { useContext } from 'react'
import buildStyles from './styles'
import AppContext from '../../context'
import { GoalInfo } from '../../../api/types'
import { useNavigate } from 'react-router-dom'
import { setSelectedGoal } from '../../context/actions'
import AppImage from '../../../components/AppImage'
import { transform } from '../../../utils/functions'

// eslint-disable-next-line @typescript-eslint/no-empty-interface
export interface GoalProps {
  goal: GoalInfo
  isBigger: boolean
  setShowedGoal: (item: GoalInfo) => void
}

const Goal = ({ goal, isBigger, setShowedGoal }: GoalProps) => {
  const { state, contextDispatch } = useContext(AppContext)
  const navigate = useNavigate()

  const TEXT_LENGTH = isBigger ? 300 : 100
  const description =
    goal && goal.description.length > 0 ? goal.description.trim() : ''
  const needToTrim = description.length > TEXT_LENGTH
  const trimmedDescription = needToTrim
    ? description.substring(0, TEXT_LENGTH)
    : description

  if (!state.locationDesignConfig) return null

  const styles = buildStyles({
    baseColors: state.locationDesignConfig?.baseColors,
  })

  return (
    <div
      className={styles.item}
      onClick={() => {
        setSelectedGoal(contextDispatch, goal)
        navigate(`${goal.id}/kwota`)
      }}
    >
      <AppImage
        imageId={goal.imageId}
        alt="goal-logo"
        disabledPadding
        maxHeight={!isBigger ? 120 : 200}
      />

      <Box className={styles.name}>{transform(goal.name)}</Box>

      <div className={styles.description}>
        {needToTrim ? trimmedDescription + '...' : description}
      </div>

      <Box display="flex" alignSelf="flex-end" height="37px" marginTop="auto">
        {needToTrim && (
          <span
            className={styles.moreButton}
            onClick={(e) => {
              e.stopPropagation()
              setShowedGoal(goal)
            }}
          >
            więcej
          </span>
        )}
      </Box>
    </div>
  )
}

export default Goal
